
export type NAVIGATION_DRAWER_ACTIVATE = { type: 'NAVIGATION_DRAWER_ACTIVATE' };
export type NAVIGATION_DRAWER_DEACTIVATE = { type: 'NAVIGATION_DRAWER_DEACTIVATE' };

export const activateNavigationDrawer = (): NAVIGATION_DRAWER_ACTIVATE => ({
    type: 'NAVIGATION_DRAWER_ACTIVATE',
});

export const deactivateNavigationDrawer = (): NAVIGATION_DRAWER_DEACTIVATE => ({
    type: 'NAVIGATION_DRAWER_DEACTIVATE',
});
